import * as constants from "./actions";
import axios from "@/plugins/axios.js";

function getDefaultState() {
  return {
    files: {
      status: null,
      data: [],
      error: null,
    },
    vehiclesUploaded: {
      status: null,
      data: [],
      error: null,
    },
  };
}

const actions = {
  [constants.GET_FILES]: async ({ commit }, params) => {
    try {
      commit(constants.GET_FILES);

      const response = await axios.get(`supplier/getSupplierVehicleExcel`, { params: { ...params } });
      commit(constants.GET_FILES_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_FILES_ERROR, error);
      throw error.response;
    }
  },
  [constants.GET_VEHICLES_UPLOADED]: async ({ commit }, params) => {
    try {
      commit(constants.GET_VEHICLES_UPLOADED);

      const response = await axios.get(`supplier/getPricesSupplierFile`, {
        params: params,
      });
      commit(constants.GET_VEHICLES_UPLOADED_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_VEHICLES_UPLOADED_ERROR, error);
      throw error.response;
    }
  }
};

const mutations = {
  [constants.GET_FILES](state) {
    state.files.status = "fetching";
    state.files.data = [];
    state.files.error = null;
  },
  [constants.GET_FILES_SUCCESS](state, response) {
    state.files.status = "success";
    state.files.data = response;
    state.files.error = null;
  },
  [constants.GET_FILES_ERROR](state, error) {
    state.files.status = "error";
    state.files.data = [];
    state.files.error = error;
  },
  [constants.GET_VEHICLES_UPLOADED](state) {
    state.vehiclesUploaded.status = "fetching";
    state.vehiclesUploaded.data = [];
    state.vehiclesUploaded.error = null;
  },
  [constants.GET_VEHICLES_UPLOADED_SUCCESS](state, response) {
    state.vehiclesUploaded.status = "success";
    state.vehiclesUploaded.data = response;
    state.vehiclesUploaded.error = null;
  },
  [constants.GET_VEHICLES_UPLOADED_ERROR](state, error) {
    state.vehiclesUploaded.status = "error";
    state.vehiclesUploaded.data = [];
    state.vehiclesUploaded.error = error;
  }
};


export default {
  state: getDefaultState(),
  actions,
  mutations,
};